var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('TransactionListTemplate',{staticClass:"intake-estimate-list-view",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"setLoading":_vm.setLoading,"persistenceKey":'intake-estimate-list',"defaultUserSettings":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }